export interface UTMParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

const UTM_STORAGE_KEY = 'vox2you_utm_params';
const UTM_EXPIRY_DAYS = 30;

export const getUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') return {};

  const urlParams = new URLSearchParams(window.location.search);
  const utmParams: UTMParams = {};

  const utmKeys: (keyof UTMParams)[] = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content'
  ];

  utmKeys.forEach(key => {
    const value = urlParams.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};

export const saveUTMParams = (params: UTMParams): void => {
  if (typeof window === 'undefined' || Object.keys(params).length === 0) return;

  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + UTM_EXPIRY_DAYS);

  const dataToStore = {
    params,
    expiry: expiryDate.getTime()
  };

  try {
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(dataToStore));
  } catch (error) {
    console.error('Erro ao salvar UTM params:', error);
  }
};

export const getStoredUTMParams = (): UTMParams => {
  if (typeof window === 'undefined') return {};

  try {
    const stored = localStorage.getItem(UTM_STORAGE_KEY);
    if (!stored) return {};

    const { params, expiry } = JSON.parse(stored);
    
    if (new Date().getTime() > expiry) {
      localStorage.removeItem(UTM_STORAGE_KEY);
      return {};
    }

    return params;
  } catch (error) {
    console.error('Erro ao recuperar UTM params:', error);
    return {};
  }
};

export const captureAndStoreUTMParams = (): UTMParams => {
  const urlParams = getUTMParams();
  
  if (Object.keys(urlParams).length > 0) {
    saveUTMParams(urlParams);
    return urlParams;
  }
  
  return getStoredUTMParams();
};

export const clearUTMParams = (): void => {
  if (typeof window === 'undefined') return;
  
  try {
    localStorage.removeItem(UTM_STORAGE_KEY);
  } catch (error) {
    console.error('Erro ao limpar UTM params:', error);
  }
};
